module.exports = __webpack_public_path__ + "img/img_manyou_hover.aed25251.png";